import { Stack } from "@mui/material"
import { LiquidationList } from "./components/liquidationList"
import * as styles from "./styles"

const View = () => {
  return (
    <Stack sx={styles.homeWrapper} gap={2}>
      <LiquidationList />
    </Stack>
  )
}

export default View
